export default __webpack_public_path__ + "static/media/play_btn.87c8570a.svg";